import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 15,
	viewBox: "0 0 13 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.03125 12.69L11.8908 7.85214L12.5586 8.5169L6.55859 14.49L0.558594 8.5169L1.22635 7.85214L6.00125 12.6056V0.490234H7.03125V12.69Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
